<template>
  <div id="app">
    <div class="container" :style="isDeletePaddings() ? { padding: 0 } : {}">
      <!-- <navbar> -->
      <div class="top-navbar_full" :style="getNavbarPadding()">
        <div class="back-btn">
          <button type="button" class="logo-button" aria-label="На головну магазину" @click="goToMainPage">
            <logo-icon />
          </button>
        </div>
        <div class="skip_btn btns_wrapper">
          <button class="favorites-nav" aria-label="Відкрити обране" @click="setIsChangePage('favorites')"><heart-icon size="20" aria-hidden="true" /></button>
          <button @click="openOrders" class="orders-button">
            Замовлення
          </button>
          <button class="to-cart-button" aria-label="Відкрити кошик" @click="setIsChangePage('cart')">
            <div
              v-if="cartElements && cartElements.qtyTotal"
              class="cart-counter"
            >
              {{ cartElements.items.length }}
            </div>
            <shopping-cart-icon
              size="24"
              class="custom-class"
            ></shopping-cart-icon>
          </button>
        </div>
      </div>
      <!-- </navbar> -->

      <home-page
        v-if="isShowPage === 'home'"
        :categories="categories"
        :mainBunner="mainBunner"
        :isShowPage="isShowPage"
        @setIsChangePage="setIsChangePage"
        @setIsOpenProductFromBunner="setIsOpenProductFromBunner"
        @setIsOpenProductsPage="setIsOpenProductsPage"
        @setIsOpenProductPage="setIsOpenProductPage"
      />

      <product-page
        v-if="isShowPage === 'product'"
        :setIsChangePage="setIsChangePage"
        @setIsChangePage="setIsChangePage"
        @setIsOpenProductPage="setIsOpenProductPage"
      />
      <favorites-page v-if="isShowPage === 'favorites'" @setIsChangePage="setIsChangePage" />
      <filter-page
        v-if="isShowPage === 'filter'"
        :categories="categories"
        :isShowPage="isShowPage"
        @setIsChangePage="setIsChangePage"
      />
      <product-info-page
        v-if="isShowPage === 'productInfo'"
        :openedProduct="openedProduct"
        @setIsChangePage="setIsChangePage"
        @setIsCloseProductPage="setIsCloseProductPage"
      />
      <card-page
        v-if="isShowPage === 'cart'"
        :addedToCardProducts="addedToCardProducts"
        @setIsChangePage="setIsChangePage"
      />
      <orders-page
        v-if="isShowPage === 'orders'"
        :addedToCardProducts="addedToCardProducts"
        @setIsChangePage="setIsChangePage"
      />
      <make-order-page
        v-if="isShowPage === 'makeOrder'"
        :addedToCardProducts="addedToCardProducts"
        :telegram="Telegram"
        @setIsChangePage="setIsChangePage"
      />
      <is-success-page
        v-if="isShowPage === 'success'"
        @setIsChangePage="setIsChangePage"
      />
      <!-- <cart> -->
      <cart-notice @open-cart="setIsChangePage('cart')" />
    </div>
  </div>
</template>

<script>
import FavoritesPage from "./resources/js/pages/FavoritesPage.vue";
import { HeartIcon, ShoppingCartIcon } from "vue-feather-icons";
import {
  GET_CATEGORIES,
} from "../src/resources/js/helpers/requests";
import HomePage from "./resources/js/pages/HomePage.vue";
import LogoIcon from "./resources/js/icons/LogoIcon.vue";
import ProductPage from "./resources/js/pages/ProductPage.vue";
import FilterPage from "./resources/js/pages/FilterPage.vue";
import ProductInfoPage from "./resources/js/pages/ProductInfoPage.vue";
import CardPage from "./resources/js/pages/CardPage.vue";
import MakeOrderPage from "./resources/js/pages/MakeOrderPage.vue";
import IsSuccessPage from "./resources/js/pages/IsSuccessPage.vue";
import OrdersPage from "./resources/js/pages/OrdersPage.vue";
import { mapMutations } from "vuex";
import CartNotice from "./components/CartNotice.vue";

export default {
  name: "app",
  components: { FavoritesPage, HeartIcon,
    CartNotice,
    ShoppingCartIcon,
    HomePage,
    ProductPage,
    LogoIcon,
    FilterPage,
    ProductInfoPage,
    CardPage,
    MakeOrderPage,
    IsSuccessPage,
    OrdersPage,
  },

  data() {
    return {
      isShowPage: "home",
      isShowHomePage: true,
      isShowFilterPage: false,
      isShowProductPage: false,
      isShowCardPage: false,
      isShowMakeOrderPage: false,
      isShowSuccessPage: false,
      openedProduct: null,
      isShowProducts: false,
      categories: [],
      openedCategoryProducts: [],
      usedCart: {},
      mainBunner: [],
      Telegram: window.Telegram.WebApp,
      isMobileDevice: false,
      addedToCardProducts: [
        {
          id: 1,
          name: "Вітаміни шипучі NOVEL Magnesium + B6 №20",
          price: 100,
          currency: "грн",
          img: require("./assets/pillImage.png"),
        },
        {
          id: 2,
          name: "Вітаміни шипучі NOVEL Magnesium + B6 №20",
          price: 100,
          currency: "грн",
          img: require("./assets/pillImage.png"),
        },
        {
          id: 3,
          name: "Вітаміни шипучі NOVEL Magnesium + B6 №20",
          price: 100,
          currency: "грн",
          img: require("./assets/pillImage.png"),
        },
      ],
    };
  },

  async mounted() {
    window.scrollTo(0, 0);
    // Визначаємо тип пристрою
    this.isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent,
    );
    try {
      this.Telegram.expand();
      if (this.isMobileDevice) {
        this.Telegram.requestFullscreen();
      }
      this.Telegram.setHeaderColor("#01bace");
      const data = JSON.stringify({ allow_vertical_swipe: false });
      window.TelegramWebviewProxy?.postEvent(
        "web_app_setup_swipe_behavior",
        data,
      );
    } catch (error) {
      console.log(error.message);
    }
    this.$store.dispatch("loadHome");
    this.$store.dispatch("loadFavorites");
    this.$store.dispatch(
      "getCartProducts",
      // 39340,
      this.parseUrl(window.location.pathname),
    );
    this.$store.dispatch(
      "getOrders",
      // 39340,
      this.parseUrl(window.location.pathname),
    );
  },
  methods: {
    openOrders() {
      this.$store.commit('setSelectedOrderId', null);
      this.$store.dispatch('getOrders');
      this.setIsChangePage('orders');
    },
    ...mapMutations(["addPerPage", "setChangeSearchText"]),
    setIsChangePage(page) {
      this.isShowPage = page;
    },
    yourMethodToSwitchPage() {
      this.setIsChangePage = "home";
    },
    goToMainPage() {
      this.setChangeSearchText("");
      this.setIsChangePage("home");
    },
    async setIsCloseProductPage() {
      this.openedProduct = null;
      let result;
      try {
        result = await GET_CATEGORIES();
        this.mainCategories = result.data;
        this.isShowProducts = false;
      } catch (error) {
        console.log(error.message);
      }
    },
    parseUrl(url) {
      try {
        const pathParts = url.split("/").filter((part) => part !== "");

        if (pathParts.length === 0) {
          return null;
        }

        const id = pathParts[0];
        if (pathParts[1] === 'cart') this.setIsChangePage('cart');
        else if (pathParts[1] === 'orders') {
          if (/^[0-9]+$/.test(pathParts[2] || '')) this.$store.commit('setSelectedOrderId', Number(pathParts[2]));
          this.setIsChangePage('orders');
        }
        return id;
      } catch (error) {
        return null;
      }
    },
    setIsOpenProductPage() {
      this.setIsChangePage("productInfo");
    },
    setIsOpenProductFromBunner(value) {
      // this.isShowPage = 'productInfo'
      this.openedProduct = value;
    },
    async setIsOpenProductsPage(id) {
      this.setIsChangePage("product");
      if (id) {
        this.$store.dispatch("getProductsReq", id);
      }
    },

    isDeletePaddings() {
      if (this.isShowPage === "filter") {
        return true;
      } else if (this.isShowPage === "productInfo") {
        return true;
      } else if (this.isShowPage === "orders") {
        return true;
      } else if (this.isShowPage === "cart") {
        return true;
      } else if (this.isShowPage === "makeOrder") {
        return true;
      } else if (this.isShowPage === "success") {
        return true;
      } else {
        return false;
      }
    },
    getNavbarPadding() {
      if (this.isMobileDevice) {
        return {
          padding: "calc(16px + var(--tg-safe-area-inset-top, env(safe-area-inset-top, 0px)) + var(--tg-content-safe-area-inset-top, 0px)) 16px 11px",
        };
      }
      return { padding: "20px 16px 11px 16px" };
    },
  },
  computed: {
    cartElements() {
      return this.$store.getters.getCustomerCart;
    },
  },
  watch: {
    async isShowPage(newValue, oldValue) {
      let value = oldValue;
      value;
      if (newValue === "home") {
        this.$store.dispatch("loadHome");
      } else if (newValue === "cart") {
        this.$store.dispatch("getCart");
      }
    },
  },
};
</script>

<style scoped>
.favorites-nav { background: #fff; color: #075a63; border: 0; min-width: 44px; min-height: 44px; display: flex; align-items: center; justify-content: center; cursor: pointer; }
.container {
  background: #fff;
  height: 50px;
}

.cards {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 15px;
  grid-auto-rows: auto;
  padding: 0px 15px 100px;
}

.cards.product-list {
  grid-template-columns: 1fr 1fr;
  grid-gap: 0px 0px;
  padding: 0px 0px 100px;
}

.appbar {
  position: fixed;
  z-index: 99;
  top: 0px;
  width: 100%;
  height: 48px;
  background: transparent;
  padding: 5px;
  display: grid;
  grid-template-columns: 36px auto 36px;
  justify-content: space-between;
  align-items: center;
  max-width: 960px;
  backdrop-filter: blur(10px);
  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 0px 0px;
  background-color: rgba(255, 255, 255, 0.79);
}

.to_order_appbar {
  position: fixed;
  z-index: 99;
  top: 0px;
  width: 100%;
  height: 48px;
  background: transparent;
  padding: 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 960px;
  backdrop-filter: blur(10px);
  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 0px 0px;
  background-color: rgba(255, 255, 255, 0.79);
}

.mirrorX {
  transform: scale(-1, 1);
}

.appbar_btn {
  position: relative;
  height: 36px;
  width: 36px;
}

.iconbtn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  padding: 1.7px 0 0 1.7px;
  background-color: unset;
  border: unset;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-right: 20px;
}

.appbar_category {
  cursor: pointer;
  text-align: center;
  -webkit-line-clamp: 2;
}

.shopcart_iconTotal {
  position: absolute;
  font-size: 8px;
  font-weight: bold;
  min-width: 2.5em;
  padding: 0 0.2em;
  top: 0;
  right: -0.2em;
  border: 1px solid #f56e22;
  border-radius: 8px;
  background: #ffede2;
}

.list {
  padding-top: 58px;
}

.shopcart_prompt {
  display: flex;
  margin: auto;
  margin-top: 2em;
  width: 80%;
  position: relative;
  align-items: center;
  min-width: 290px;
  max-width: 600px;
  min-height: 73px;
  background-color: #000000;
  border-radius: 8px;
  cursor: pointer;
}

.shopcart_prompt_text {
  color: #f3f3f3;
  margin: auto;
  padding: 20px;
  text-align: center;
  font-size: 14px;
}

.shopcart_prompt_text_info {
  font-family: sans-serif;
}

.shopcart_prompt_icon {
  position: absolute;
  top: -15px;
  right: 20px;
}

.shopcart {
  padding: 1em 5px 7em;
  padding-top: 58px;
  max-width: 960px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.shopcart_product {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px #eeeeee;
  padding: 0.6em;
}

.shopcart_product_footer,
.shopcart_product_header {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
}

.shopcart_product_footer--price,
.shopcart_product_header--price {
  color: #2196f3;
  min-width: 7em;
  text-align: end;
}

.shopcart_delivery {
  padding: 0.6em;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #eeeeee;
}

.shopcart_total {
  padding: 0.6em;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.to-cart-button svg {
  color: #343745;
}

button,
button:active,
button:focus {
  outline: none;
}

.cart {
  right: 20px;
}

/**new styles*/

.input-group {
  position: relative;
  display: flex;
  align-items: stretch;
}

.form-control {
  padding: 8px 15px;
  border: 1px solid #eee;
  line-height: 22px;
  border-radius: 5px;
  font-size: 13px;
  color: #999;
}

input:focus,
input:active,
.form-control:focus,
.form-control:active {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #eee;
  color: #777;
}

.search-text {
  background: #f0f0f0 !important;
  padding: 12px;
  border: none;
  color: #000;
  font-family: "Space Grotesk", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  padding-left: 50px;
}

.search-text::placeholder {
  color: #707070;
  font-family: "Space Grotesk", sans-serif;
}

.search-iconn:focus-visible,
.search-text:focus {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.search-filter-btn a {
  border-radius: 8px;
  background: #ff4c3b;
  padding: 12px;
  display: inline-block;
}

.search-input-icon {
  position: absolute;
  top: 12px;
  left: 12px;
}

.filter-button-icon {
  width: 24px;
  height: 24px;
  transform: rotate(90deg);
  color: #fff;
}

.filter-button {
  width: 48px;
  height: 48px;
  background: #01bace;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.nav-pills {
  display: flex;
  list-style: none;
}

.bottombar {
  position: fixed;
  bottom: 0;
  left: 50%;
  padding: 12px 0px;
  z-index: 10;
  transform: translateX(-50%);
  width: 100%;
  max-width: 960px;
  margin: auto;
  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 0px 0px;
  background-color: rgba(255, 255, 255, 0.79);
  backdrop-filter: blur(10px);
}

.tabs-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
  margin: auto;
}

.tabs-inner button {
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  color: #999999;
  margin: 0px 40px;
  position: relative;
}

.tabs-inner .tab.active {
  color: #2196f3;
}

.tabs-inner .tab.active svg {
  fill: #2196f3;
}

.tabs-inner button svg {
  width: 30px;
  height: auto;
  margin-bottom: 8px;
  fill: #999999;
}

.tabs-inner button .total-sum {
  position: absolute;
  font-size: 10px;
  width: 100%;
  top: 0;
  right: -32px;
  background: #2196f3;
  color: #fff;
  border-radius: 6px;
  padding: 2px 4px;
}

.to_order_menu_page {
  padding-top: 58px;
}

.to_order_title {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #000000;
}

.to_order_menu_container {
  max-width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ........................... */

.text-field {
  margin-bottom: 1rem;
}

.text-field__label {
  display: block;
  margin-bottom: 0.25rem;
  color: #757575;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.text-field__input {
  display: block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #bdbdbd;
  border-radius: 12px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.text-field__input[type="search"]::-webkit-search-decoration,
.text-field__input[type="search"]::-webkit-search-cancel-button,
.text-field__input[type="search"]::-webkit-search-results-button,
.text-field__input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
}

.text-field__input::placeholder {
  color: #212529;
  opacity: 0.4;
}

.text-field__input:focus {
  color: #212529;
  background-color: #fff;
  border-color: #bdbdbd;
  outline: 0;
}

.text-field__input:disabled,
.text-field__input[readonly] {
  background-color: #f5f5f5;
  opacity: 1;
}

/* with floating label */
.text-field_floating {
  position: relative;
}

.text-field_floating .text-field__input {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
  padding: 1rem 0.75rem;
}

.text-field_floating .text-field__label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.75rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
}

.text-field_floating .text-field__input::-moz-placeholder {
  color: transparent;
}

.text-field_floating .text-field__input::placeholder {
  color: transparent;
}

.text-field_floating .text-field__input:focus,
.text-field_floating .text-field__input:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.text-field_floating .text-field__input:focus ~ .text-field__label,
.text-field_floating
  .text-field__input:not(:placeholder-shown)
  ~ .text-field__label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.75rem) translateX(0.15rem);
}

.wrong_label {
  color: #ff2c20;
}

.wrong_format_message {
  margin-top: 8px;
  color: #ff2c20;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.opened_input_options_container {
  width: 100%;
  position: relative;
}

.opened_input_result_text {
  position: relative;
  border-radius: 12px;
  border: 1px solid #bdbdbd;
  padding: 8px 16px;
  height: 58px;
}

.opened_input_results {
  position: absolute;
  width: 100%;
  border: 1px solid #bdbdbd;
  background: #fff;
  border-radius: 5px;
  padding: 10px;
  z-index: 100;
}

.opened_input_text {
  padding: 5px;
  color: #000;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.opened_input_icon {
  position: absolute;
  right: 20px;
  top: 18px;
  transition: all 0.5s ease;
}

.opened_input_rotate {
  transform: rotate(180deg);
}

.opened_input_placeholder {
  position: absolute;
  top: 18px;
  left: 10px;
  height: 100%;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  color: #757575;
  font-size: 16px;
  transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
}

.active_opened {
  top: 6px;
  left: 10px;
  font-size: 13px;
}

.used_input_delivery_name {
  margin-top: 20px;
}

.small_inputs_container {
  display: flex;
  gap: 20px;
}

.error_number_icon {
  position: absolute;
  top: 18px;
  right: 20px;
  color: #ff2c20;
}

.success-payment-method-icon {
  position: absolute;
  top: 18px;
  right: 20px;
}

.send_order_button {
  padding: 16px 24px;
  width: 100%;
  border-radius: 12px;
  background: #1f1f1f;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

@media (min-width: 700px) {
  .to_order_menu_container {
    max-width: 50%;
  }
}

/* new styles */

.top-navbar_full {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 100px 16px 11px 16px;
}
.skip_btn a {
  color: #707070;
  text-align: right;
  font-family: "Lato", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.noresult-screen-full {
  display: flex;
  align-items: center;
  column-gap: 12px;
}

.to-cart-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: relative;
}

.cart-counter {
  position: absolute;
  height: 12px;
  min-width: 12px;
  background: #01bace;
  border-radius: 50%;
  padding: 2px;
  color: #fff;
  font-family: "Lato", sans-serif;
  font-size: 8px;
  font-weight: 700;
  line-height: 8px;
  top: -1px;
  right: -4px;
}
.logo-button {
  background: transparent;
  border: none;
  cursor: pointer;
}
.orders-button {
  border-radius: 4px;
  background: #00bcd4;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  cursor: pointer;
  transition: background 0.2s;
  padding: 5px;
}
.orders-button:hover {
  background: #0096e6;
}

.btns_wrapper {
  display: flex;
  flex-direction: row;
}

/* === Покращені стилі для великих екранів (1024px+) === */
@media (min-width: 1024px) {
  /* Головний контейнер */
  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
    background: #fff;
  }

  /* Навігаційна панель */
  .top-navbar_full {
    padding: 30px 0 20px 0;
    max-width: 1400px;
    margin: 0 auto;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 30px;
  }

  /* Продукти в сітці */
  .cards.product-list {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 24px;
    padding: 40px 0 120px 0;
    max-width: 1400px;
    margin: 0 auto;
  }

  /* Appbar для великих екранів */
  .appbar,
  .to_order_appbar {
    max-width: 1400px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 0 0 16px 16px;
    padding: 10px 40px;
    height: 60px;
  }

  /* Bottom bar */
  .bottombar {
    max-width: 1400px;
    border-radius: 16px 16px 0 0;
  }

  /* Shopcart */
  .shopcart {
    max-width: 1200px;
    margin: 0 auto;
    padding: 60px 40px 120px 40px;
  }

  /* Кнопки */
  .orders-button {
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 8px;
    transition: all 0.3s ease;
  }

  .orders-button:hover {
    background: #0096e6;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 188, 212, 0.3);
  }

  .to-cart-button {
    transition: transform 0.2s;
  }

  .to-cart-button:hover {
    transform: scale(1.1);
  }

  .cart-counter {
    font-size: 10px;
    min-width: 18px;
    height: 18px;
    padding: 4px;
  }

  /* Збільшення логотипу */
  .logo-button {
    padding: 8px;
    transition: transform 0.3s ease;
  }

  .logo-button:hover {
    transform: scale(1.05);
  }

  .logo-button svg {
    width: 200px;
    height: auto;
    max-width: none;
  }

  /* Menu container */
  .to_order_menu_container {
    max-width: 700px;
    margin: 0 auto;
  }

  /* Покращені відступи */
  .top-navbar_full:has(.logo-button) {
    gap: 40px;
  }
}
</style>

<style>
.toast-top-center {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  right: auto !important;
  bottom: auto !important;
  width: max-content;
  z-index: 9999;
  position: fixed !important;
  pointer-events: auto;
}
</style>
